module.exports = __webpack_public_path__ + "static/img/sy-img4.53d44a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sy-img4.png
// module id = y5f0
// module chunks = 1